import { AUTH_RETURN_PATH_KEY } from "../constants";

const PUBLIC_PATH_PATTERNS = [
  /^\/incidences\/seguimiento\/[a-f0-9]{24}$/i,
];

const SKIP_PATHS = new Set(["/", "/login", "/logout"]);

export const isPublicAuthPath = (pathname) =>
  PUBLIC_PATH_PATTERNS.some((pattern) => pattern.test(pathname));

export const shouldSaveAuthReturnPath = (pathname) => {
  if (!pathname || SKIP_PATHS.has(pathname)) {
    return false;
  }
  return !isPublicAuthPath(pathname);
};

export const saveAuthReturnPath = (pathname, search = "") => {
  if (!shouldSaveAuthReturnPath(pathname)) {
    return;
  }
  const returnPath = `${pathname}${search || ""}`;
  sessionStorage.setItem(AUTH_RETURN_PATH_KEY, returnPath);
};

export const getAuthReturnPath = () =>
  sessionStorage.getItem(AUTH_RETURN_PATH_KEY);

export const clearAuthReturnPath = () => {
  sessionStorage.removeItem(AUTH_RETURN_PATH_KEY);
};

export const getRouteKeyFromPath = (path) => {
  const pathname = path.split("?")[0];
  const segments = pathname.split("/").filter(Boolean);
  return segments[segments.length - 1] || "home";
};
